import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

export class BaseApi {
  axios: AxiosInstance;

  constructor(config?: AxiosRequestConfig) {
    this.axios = axios.create(config);
  }
}